import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import {
  BiomassBenchmarkEvaluationCropFieldRequest,
  BiomassBenchmarkEvaluationResponseDto,
  BiomassBenchmarkResponseDto,
  WaterAuthorityExceedanceResultDto,
} from '../models/models';

@Injectable({
  providedIn: 'root',
})
export class DataPlatformApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.APIM_BASE_URL}/data-platform-integration-service/`;

  getWaterAuthorityExceedances(waterAuthorityIds: number[]): Observable<WaterAuthorityExceedanceResultDto[]> {
    let params = new HttpParams();
    waterAuthorityIds.forEach((id) => {
      params = params.append('waterAuthorityId', id.toString());
    });

    const url = `${this.baseUrl}water-authority-exeedence`;
    return this.http.get<WaterAuthorityExceedanceResultDto[]>(url, { params });
  }

  getBiomassBenchmark(
    cropFieldId: number,
    cropYear: number,
    cropVarietyId: number,
  ): Observable<BiomassBenchmarkResponseDto> {
    const params = new HttpParams().set('cropVarietyId', cropVarietyId.toString());
    const url = `${this.baseUrl}biomass-benchmark/${cropFieldId}/${cropYear}`;
    return this.http.get<BiomassBenchmarkResponseDto>(url, { params });
  }

  getBiomassBenchmarkEvaluation(
    cropYear: number,
    cropFields: BiomassBenchmarkEvaluationCropFieldRequest[],
  ): Observable<BiomassBenchmarkEvaluationResponseDto> {
    let params = new HttpParams();
    cropFields.forEach(({ cropFieldId, cropVarietyId }) => {
      params = params.append('cropFieldIds', cropFieldId.toString());
      params = params.append('cropVarietyIds', cropVarietyId.toString());
    });

    const url = `${this.baseUrl}biomass-benchmark/evaluation/${cropYear}`;
    return this.http.get<BiomassBenchmarkEvaluationResponseDto>(url, { params });
  }
}
